import { render, staticRenderFns } from "./pinpaizhanshi.vue?vue&type=template&id=1e051cea&"
import script from "./pinpaizhanshi.vue?vue&type=script&lang=js&"
export * from "./pinpaizhanshi.vue?vue&type=script&lang=js&"
import style0 from "./pinpaizhanshi.vue?vue&type=style&index=0&id=1e051cea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports